module.exports = __webpack_public_path__ + "static/media/weixin.a173d8f8.svg";